'use client'

import { Box, Divider } from '@mantine/core'
import React from 'react'

export default function ThickDivider({ hideOnDesktop = false }: { hideOnDesktop?: boolean }) {
    return (
        <>
            {/* Use md breakpoint so dividers show on iPads/tablets. */}
            <Box
                data-thick-divider
                hiddenFrom="md"
                style={{
                    position: 'relative',
                    left: '50%',
                    marginLeft: '-50vw',
                    marginRight: '-50vw',
                    width: '100vw',
                    background: '#2B2A2A0D',
                    height: '16px',
                }}
            />
            {!hideOnDesktop && <Divider data-thick-divider size="xl" visibleFrom="md" />}
        </>
    )
}
